import { email, requiredIf, required } from 'vuelidate/lib/validators'
import phones from '@/assets/validateForms/Phones'
import emails from '@/assets/validateForms/Emails'
import addresses from '@/assets/validateForms/Address'
import contacts from '@/assets/validateForms/Contacts'
import UserService from '@/services/UserService'

const isUniqueUsername = async function (value) {
  if (!value) return true
  try {
    const isNotUnique = await UserService.checkUsernameValidity(value, this.entity.userId)
    return !isNotUnique
  } catch (e) {
    return false
  }
}

const isUniqueEmail = async function (value) {
  if (!value) return true
  try {
    const isUnique = await UserService.checkEmailValidity(value, this.entity.userId)
    return isUnique
  } catch (e) {
    return false
  }
}

const requiredIfNotDeleted = requiredIf(function (model) {
  return !model.isDeleted
})

const emailIfNotDeleted = (value, model) => {
  if (model.isDeleted) return true
  return email(value)
}

const isAccessControlSelected = async function (value) {
  if (value.length <= 0) return false
  try {
    return value.filter((p) => p.isBlock || p.isRead || p.isAdd || p.isEdit || p.isDelete || p.isPrint).length > 0
  } catch (e) {
    return false
  }
}

const uniqueType = function (value) {
  if (!Array.isArray(value)) return true
  const types = value.filter((a) => !a.isDeleted).map((a) => a.type)
  return new Set(types).size === types.length
}

export default {
  provide: function () {
    return {
      $vv: this.$v
    }
  },
  validations: {
    detailGroup: ['entity.email', 'entity.username', 'entity.password', 'entity.confirmNewPassword'],
    emailsPhonesGroup: ['entity.emails', 'entity.phones'],
    addressesGroup: ['entity.addresses'],
    contactsGroup: ['entity.contacts'],
    profileAddressesGroup: ['entity.profile.assetAddresses'],
    profileEmailsGroup: ['entity.profile.assetEmails'],
    profilePhonesGroup: ['entity.profile.assetPhones'],
    userAccessControl: ['entity.userAccessControl'],
    entity: {
      username: {
        required,
        isUniqueUsername
      },
      password: {
        required: requiredIf((model) => {
          return model.isNew == true
        })
      },
      confirmNewPassword: {
        required: requiredIf((model) => {
          return model.isNew == true
        })
      },
      email: {
        email,
        required,
        isUniqueEmail
      },
      ...addresses,
      ...emails,
      ...phones,
      ...contacts,
      profile: {
        assetAddresses: {
          $each: {
            address1: { required: requiredIfNotDeleted },
            suburbText: { required: requiredIfNotDeleted },
            stateCode: { required: requiredIfNotDeleted },
            stateText: { required: requiredIfNotDeleted },
            suburbPostcode: { required: requiredIfNotDeleted },
            countryCode: { required: requiredIfNotDeleted },
            countryText: { required: requiredIfNotDeleted }
          },
          uniqueType
        },
        assetEmails: {
          $each: {
            address: {
              required: requiredIfNotDeleted,
              email: emailIfNotDeleted
            }
          },
          uniqueType
        },
        assetPhones: {
          $each: {
            no: { required: requiredIfNotDeleted }
          },
          uniqueType
        }
      },
      userAccessControl: {
        isAccessControlSelected
      }
    }
  }
}
